// Constants
import { RESET_STATE } from '../auth/constants';
import { TIMESHEET_SET } from './constants';

// Types
import type { Timesheet } from '../timesheets/types';

const initialState = null;

type State = ?Timesheet;

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case TIMESHEET_SET:
            return action.payload;
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
